import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  SimpleGrid,
  useToast,
  Text,
  Flex,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Textarea,
  GridItem,
  Select,
} from '@chakra-ui/react';

import React, { useEffect } from 'react';
import {
  exportMalamPayrollFile,
  exportRawXlsxFile,
  generateShiklulitPayrollFile,
  generatePayroDeductionsReport,
  generatePayroDeductionsReportWithPhone,
  generateShiklulitPayrollFileFromTransfers,
  exportMalamPayrollFileFromTransfers,
  exportHilanPayrollFileFromTransfers,
} from '../../../../functions/generatePayrollFile';
import ReportsApi, { Reports, ReportState } from '../../../../api/reports';
import { DocumentTypesEnum } from './DocumentTypeEnum';
import { ChevronDownIcon } from '@chakra-ui/icons';
import {
  exportHalperinTransfersFeesFile,
  exportHomeCenterTransfersFeesFile,
  exportMokedEmunTransfersFeesFile,
  exportPazDetailedReport,
  exportPazSummaryReport,
  exportDetailedReferencesReport,
  exportXtrasTransfersFeesFile,
} from '../../../../functions/generateReports';
import SendInvoiceEmailModal from './SendInvoiceEmailModal';
import User from '../../../../api/user';
import { downloadPdf } from '../../../../functions/file.utils';

export default function AdminReportDetailsModal(props) {
  let { isOpen, onClose, report } = props;
  const toast = useToast();

  const [totalTransfers, setTotalTransfers] = React.useState(0);
  const [totalEmployeesTransferFees, setTotalEmployeesTransferFees] = React.useState(0);
  const [totalCompanyServiceSubscriptionFee, setTotalCompanyServiceSubscriptionFee] =
    React.useState(0);
  const [totalSettlementAmount, setTotalSettlementAmount] = React.useState(0);
  const [reportState, setReportState] = React.useState('0');
  const [payPeriod, setPayPeriod] = React.useState('');
  const [companyId, setCompanyId] = React.useState('');
  const [companyName, setCompanyName] = React.useState('');
  const [reportId, setReportId] = React.useState('');
  const [notes, setNotes] = React.useState('');
  const [selectedDocumentType, setSelectedDocumentType] = React.useState(null);
  const [documents, setDocuments] = React.useState([]);
  const [isCreatingDocument, setIsCreatingDocument] = React.useState(false);
  const [sendEmailModalOpen, setSendEmailModalOpen] = React.useState(false);
  const [currentReportData, setCurrentReportData] = React.useState(null);
  const [isSyncing, setIsSyncing] = React.useState(false);
  const [deductionReportOnlyMode, setDeductionReportOnlyMode] = React.useState(false);

  const loadReportDetails = () => {
    if (report && report.id) {
      ReportsApi.getReportFullDetails(report.id)
        .then((response) => {
          const reportJson = response.data;
          setReportId(reportJson.id);
          setTotalTransfers(reportJson.transfersAmount);
          setTotalEmployeesTransferFees(reportJson.usersTransfersFee);
          setTotalCompanyServiceSubscriptionFee(reportJson.totalCompanyServiceSubscriptionFee);
          setTotalSettlementAmount(reportJson.settlementTotalAmount);
          setPayPeriod(reportJson.payPeriod);
          setCompanyId(reportJson.companyId);
          setCompanyName(reportJson.companyName);
          setNotes(reportJson.notes);
          setReportState(reportJson.state);
          setDocuments(reportJson.documents);
          setCurrentReportData(reportJson);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  useEffect(() => {
    if (isOpen && report) {
      setDocuments([]);
      loadReportDetails();
    }
    if (!isOpen) {
      setDocuments([]);
      setReportId('');
      setTotalTransfers(0);
      setTotalEmployeesTransferFees(0);
      setTotalCompanyServiceSubscriptionFee(0);
      setTotalSettlementAmount(0);
      setPayPeriod('');
      setCompanyId('');
      setCompanyName('');
      setNotes('');
      setReportState('0');
      setCurrentReportData(null);
    }
  }, [isOpen]);

  const handleAdvancePaymentRequestClick = () => {
    setSelectedDocumentType(DocumentTypesEnum.EMPLOYEE_ADVANCE_TRANSFER_REQUEST);
  };

  const handleTransferFeeInvoiceClick = () => {
    setSelectedDocumentType(DocumentTypesEnum.EMPLOYEE_TRANSFERS_FEE_INVOICE);
  };

  const handleSubscriptionFeeFeeInvoiceClick = () => {
    setSelectedDocumentType(DocumentTypesEnum.COMPANY_SUBSCRIPTION_FEE_INVOICE);
  };

  useEffect(() => {
    if (selectedDocumentType && !isCreatingDocument) {
      createDocument();
    }
  }, [selectedDocumentType]);

  const errorMapping = {
    1: 'לא נמצא מספר מסמך בתגובה מסמיט.',
    2: 'המסמך לא נשמר במסד הנתונים.',
  };

  const createDocument = async () => {
    setIsCreatingDocument(true);
    const documentDto = {
      isDraft: true,
      selectedDocumentType: selectedDocumentType,
      reportId: report.id,
    };

    ReportsApi.createDocument(documentDto)
      .then((res) => {
        if (res.data.success) {
          toast({
            title: 'המסמך נוצר בהצלחה',
            position: 'top',
            status: 'success',
            isClosable: false,
          });

          // Reload document list without closing the modal
          loadReportDetails();
        } else {
          const errorCode = res.data.errorCode;
          toast({
            title: errorMapping[errorCode] || 'שגיאה ביצירת המסמך',
            position: 'top',
            status: 'error',
            isClosable: false,
          });
        }

        // Reset for next document creation
        setSelectedDocumentType(null);
        setIsCreatingDocument(false);
      })
      .catch((e) => {
        toast({
          title: 'שגיאה ביצירת המסמך',
          position: 'top',
          status: 'error',
          isClosable: false,
        });

        // Reset for next document creation
        setSelectedDocumentType(null);
        setIsCreatingDocument(false);
      });
  };

  const handleOnUpdate = () => {
    ReportsApi.updateReport(reportId, notes, reportState)
      .then((res) => {
        toast({
          title: 'עודכן בהצלחה',
          position: 'top',
          status: 'success',
          isClosable: false,
        });
        onClose();
      })
      .catch((e) => {
        toast({
          title: 'שגיאה',
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleStatusChange = (event) => {
    const value = event.target.value;
    setReportState(value);
  };

  const handlePayrollExportClick = () => {
    // Get transfers fees report data and generate Excel directly
    ReportsApi.getTransfersListWithFee(payPeriod, companyId)
      .then((res) => {
        const transfersData = res.data;
        generatePayroDeductionsReport(transfersData, payPeriod, companyId);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת הדו"ח`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handlePayrollWithPhoneExportClick = () => {
    ReportsApi.getTransfersListWithFee(payPeriod, companyId)
      .then((res) => {
        generatePayroDeductionsReportWithPhone(res.data, payPeriod, companyId);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת הדו"ח`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleShiklulitExportClick = () => {
    // Get transfers fees report data and generate Shiklulit Excel directly
    ReportsApi.getTransfersListWithFee(payPeriod, companyId)
      .then((res) => {
        const transfersData = res.data;
        generateShiklulitPayrollFileFromTransfers(payPeriod, transfersData);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת הדו"ח`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleDownloadTransfersListWithFeeHomeCenterClick = () => {
    ReportsApi.getTransfersListWithFee(payPeriod, companyId)
      .then((res) => {
        const jsonData = res.data;
        exportHomeCenterTransfersFeesFile(jsonData, toast, payPeriod, companyId);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת המסמך`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleDownloadTransfersListWithFeeMokedEmunClick = () => {
    ReportsApi.getTransfersListWithFee(payPeriod, companyId)
      .then((res) => {
        const jsonData = res.data;
        exportMokedEmunTransfersFeesFile(jsonData, toast, payPeriod, companyId);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת המסמך`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleDownloadTransfersListWithFeeHalperinClick = () => {
    ReportsApi.getTransfersListWithFee(payPeriod, companyId)
      .then((res) => {
        const jsonData = res.data;
        exportHalperinTransfersFeesFile(jsonData, toast, payPeriod, companyId);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת המסמך`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleDownloadTransfersListWithFeeXtrasClick = () => {
    ReportsApi.getTransfersListWithFee(payPeriod, companyId)
      .then((res) => {
        const jsonData = res.data;
        exportXtrasTransfersFeesFile(jsonData, toast, payPeriod, companyId);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת המסמך`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleMalamExportClick = () => {
    // Get transfers fees report data and generate Malam Excel directly
    ReportsApi.getTransfersListWithFee(payPeriod, companyId)
      .then((res) => {
        const transfersData = res.data;
        exportMalamPayrollFileFromTransfers(payPeriod, transfersData);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת הדו"ח`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleHilanExportClick = () => {
    // Get transfers fees report data and generate Hilan Excel directly
    ReportsApi.getTransfersListWithFee(payPeriod, companyId)
      .then((res) => {
        const transfersData = res.data;
        exportHilanPayrollFileFromTransfers(payPeriod, transfersData);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת הדו"ח`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handlePazDetailedReportClick = () => {
    ReportsApi.getPazReports(payPeriod, companyId)
      .then((res) => {
        const jsonData = res.data;
        exportPazDetailedReport(jsonData.detailed, toast);
      })
      .catch((e) => {
        console.log('error is: ', e);
        console.error('Error fetching Paz detailed report: ', e);
        toast({
          title: `שגיאה בהורדת הדו"ח המפורט`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handlePazSummaryReportClick = () => {
    ReportsApi.getPazReports(payPeriod, companyId)
      .then((res) => {
        const jsonData = res.data;
        exportPazSummaryReport(jsonData.summary, toast);
      })
      .catch((e) => {
        console.log('error is: ', e);
        console.error('Error fetching Paz summary report: ', e);
        toast({
          title: `שגיאה בהורדת הדו"ח המסכם`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const getMonthNameFromPayPeriod = (period) => {
    if (!period) return 'Report';
    const match = String(period).match(/^(\d{4})-(\d{2})/);
    if (match) {
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const monthIndex = parseInt(match[2], 10) - 1;
      return months[monthIndex] || period;
    }
    return period;
  };

  const handleDetailedReferencesReportClick = () => {
    ReportsApi.getPazReports(payPeriod, companyId)
      .then((res) => {
        const jsonData = res.data;
        const monthName = getMonthNameFromPayPeriod(payPeriod);
        exportDetailedReferencesReport(jsonData.detailed, toast, monthName, companyId);
      })
      .catch((e) => {
        console.log('error is: ', e);
        console.error('Error fetching detailed references report: ', e);
        toast({
          title: `שגיאה בהורדת דוח מפורט אסמכתאות`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handlePazPeriodicReport = () => {
    ReportsApi.getPazReports(`PERIODIC:${payPeriod}`, companyId)
      .then((res) => {
        const jsonData = res.data;
        exportPazSummaryReport(jsonData.summary, toast, 'Paz-Report-All-Period.xlsx');
      })
      .catch((e) => {
        console.log('error is: ', e);
        console.error('Error fetching Paz periodic report: ', e);
        toast({
          title: `שגיאה בהורדת הדו"ח התקופתי`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleTeam3ExportClick = () => {
    ReportsApi.downloadReport(1, payPeriod, companyId, 'team3')
      .then((res) => {
        const base64String = new TextDecoder().decode(res.data);
        const byteCharacters = atob(base64String);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Deductions-Report-Company-${companyId}-${payPeriod}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת דו"ח צוות 3`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleCarrefourExportClick = () => {
    ReportsApi.downloadReport(1, payPeriod, companyId, 'carrefour')
      .then((res) => {
        // Backend sends base64 text; arraybuffer contains the raw bytes of that string
        const base64String = new TextDecoder().decode(res.data);
        const byteCharacters = atob(base64String);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Carrefour-Report-Company-${companyId}-${payPeriod}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((e) => {
        toast({
          title: `שגיאה בהורדת הדו"ח`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handlePazAllReports = async () => {
    try {
      // Download detailed report
      const detailedResponse = await ReportsApi.getPazReports(payPeriod, companyId);
      exportPazDetailedReport(detailedResponse.data.detailed, toast);

      // Small delay between downloads
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Download summary report
      const summaryResponse = await ReportsApi.getPazReports(payPeriod, companyId);
      exportPazSummaryReport(summaryResponse.data.summary, toast);

      // Small delay between downloads
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Download periodic report (all time up to selected period)
      const periodicResponse = await ReportsApi.getPazReports(`PERIODIC:${payPeriod}`, companyId);
      exportPazSummaryReport(periodicResponse.data.summary, toast, 'Paz-Report-All-Period.xlsx');

      // Success message after all downloads
      toast({
        title: 'הורדת כל הדוחות הושלמה',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    } catch (e) {
      console.log('error is: ', e);
      console.error('Error fetching Paz all reports: ', e);
      toast({
        title: `שגיאה בהורדת הדוחות`,
        position: 'top',
        status: 'error',
        isClosable: false,
      });
    }
  };

  const handleSyncTransfersReport = () => {
    setIsSyncing(true);
    ReportsApi.syncTransfersReport(reportId)
      .then((res) => {
        const result = res.data;
        toast({
          title: 'סנכרון דוח ניכויים הושלם בהצלחה',
          description: `עודכנו ${result.transfersCount} העברות`,
          position: 'top',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });

        // Update the displayed totals with the fresh data
        setTotalTransfers(result.transfersAmount);
        setTotalEmployeesTransferFees(result.usersTransfersFee);

        // Reload the full report details to get all updated data
        loadReportDetails();
      })
      .catch((e) => {
        console.error('Error syncing transfers report: ', e);
        toast({
          title: `שגיאה בסנכרון דוח ניכויים`,
          description: 'אנא נסה שוב מאוחר יותר',
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      })
      .finally(() => {
        setIsSyncing(false);
      });
  };

  const handleApproveReportClick = () => {
    ReportsApi.approveReport(reportId)
      .then((res) => {
        toast({
          title: `הד״וח עודכן בהצלחה`,
          position: 'top',
          status: 'success',
          isClosable: false,
        });

        // Reload document list without closing the modal
        loadReportDetails();
      })
      .catch((e) => {
        toast({
          title: `שגיאה בעדכון הדו״ח`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      });
  };

  const handleSendEmailClick = () => {
    // Only open send email modal if there are documents
    if (documents && documents.length > 0) {
      setDeductionReportOnlyMode(false);
      setSendEmailModalOpen(true);
    } else {
      toast({
        title: 'אין מסמכים לשליחה',
        description: 'יש ליצור מסמכים לפני שליחת אימייל',
        position: 'top',
        status: 'warning',
        isClosable: true,
      });
    }
  };

  const handleDownloadFilesClick = async () => {
    // Check if there are any documents
    if (!documents || documents.length === 0) {
      toast({
        title: 'אין מסמכים להורדה',
        description: 'יש ליצור מסמכים לפני ההורדה',
        position: 'top',
        status: 'warning',
        isClosable: true,
      });
      return;
    }

    // Download each document
    for (const doc of documents) {
      try {
        // Determine the document type based on the document name or type
        let documentType;
        if (
          doc.docName.includes('עמלות') ||
          doc.type === DocumentTypesEnum.EMPLOYEE_TRANSFERS_FEE_INVOICE
        ) {
          documentType = DocumentTypesEnum.EMPLOYEE_TRANSFERS_FEE_INVOICE;
        } else if (
          doc.docName.includes('מקדמות') ||
          doc.type === DocumentTypesEnum.EMPLOYEE_ADVANCE_TRANSFER_REQUEST
        ) {
          documentType = DocumentTypesEnum.EMPLOYEE_ADVANCE_TRANSFER_REQUEST;
        } else if (
          doc.docName.includes('מנוי') ||
          doc.type === DocumentTypesEnum.COMPANY_SUBSCRIPTION_FEE_INVOICE
        ) {
          documentType = DocumentTypesEnum.COMPANY_SUBSCRIPTION_FEE_INVOICE;
        } else {
          continue; // Skip unknown document types
        }

        // Download the PDF
        const res = await ReportsApi.downloadDocumentPdf(documentType, reportId);
        downloadPdf(res, `${doc.docName}_${doc.docId}.pdf`);

        // Small delay between downloads to avoid overwhelming the browser
        await new Promise((resolve) => setTimeout(resolve, 500));
      } catch (e) {
        console.error('Error downloading document:', doc.docId, e);
        toast({
          title: `שגיאה בהורדת ${doc.docName}`,
          position: 'top',
          status: 'error',
          isClosable: false,
        });
      }
    }

    // Success message after all downloads
    toast({
      title: 'הורדת הקבצים הושלמה',
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'top',
    });
  };

  const handleSendDeductionReportOnlyClick = () => {
    // Open send email modal for deduction report only (without documents requirement)
    setDeductionReportOnlyMode(true);
    setSendEmailModalOpen(true);
  };

  const handleSendReminderEmailClick = async () => {
    const contactEmails = (() => {
      if (!currentReportData?.contactEmails) return [];
      if (Array.isArray(currentReportData.contactEmails)) {
        return currentReportData.contactEmails
          .map((e) => e.trim().replace(/^\[|\]$/g, ''))
          .filter(Boolean);
      }
      let s = String(currentReportData.contactEmails).trim();
      if (s.startsWith('[') && s.endsWith(']')) s = s.slice(1, -1);
      return s
        .split(',')
        .map((e) => e.trim())
        .filter(Boolean);
    })();

    if (contactEmails.length === 0) {
      toast({
        title: 'אין כתובת מייל מוגדרת לחברה זו',
        status: 'warning',
        position: 'top',
        isClosable: true,
      });
      return;
    }

    try {
      await ReportsApi.sendReminderEmail(reportId, contactEmails);
      toast({
        title: 'תזכורת נשלחה בהצלחה',
        status: 'success',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
    } catch (e) {
      toast({ title: 'שגיאה בשליחת התזכורת', status: 'error', position: 'top', isClosable: false });
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent maxW="500px" maxH="90vh" display="flex" flexDirection="column">
          <ModalHeader flexShrink={0}>
            פרטי דו״ח:
            <Flex justifyContent="space-between" alignItems="center" p={2}>
              <Text fontSize="20px">{companyName}</Text>
              <Text fontSize="20px">{payPeriod}</Text>
            </Flex>
          </ModalHeader>
          <ModalBody overflowY="auto" flex="1" minH={0} pb={4}>
            <SimpleGrid marginTop="00px" columns={{ sm: 2 }} gap="10px" mb="0px">
              <Menu>
                <MenuButton
                  backgroundColor={'green.200'}
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                  isDisabled={isCreatingDocument}
                >
                  הורד דו״ח ניכויים
                </MenuButton>
                <MenuList>
                  <MenuItem onClick={handlePayrollExportClick}>Payro</MenuItem>
                  <MenuItem onClick={handlePayrollWithPhoneExportClick}>
                    Payro + מספר טלפון
                  </MenuItem>
                  <MenuItem onClick={handleDownloadTransfersListWithFeeHalperinClick}>
                    (הלפרין) Payro מפורט
                  </MenuItem>
                  <MenuItem onClick={handleDownloadTransfersListWithFeeHomeCenterClick}>
                    (הום סנטר) Payro מפורט
                  </MenuItem>
                  <MenuItem onClick={handleDownloadTransfersListWithFeeMokedEmunClick}>
                    (מוקד אמון) Payro מפורט
                  </MenuItem>
                  <MenuItem onClick={handleDownloadTransfersListWithFeeXtrasClick}>
                    (xtras) Payro מפורט
                  </MenuItem>
                  <MenuItem onClick={handleDetailedReferencesReportClick}>
                    (אסמכתאות) Payro מפורט
                  </MenuItem>
                  <MenuItem onClick={handleShiklulitExportClick}>שקלולית</MenuItem>
                  <MenuItem onClick={handleMalamExportClick}>מלם</MenuItem>
                  <MenuItem onClick={handleHilanExportClick}>הילן</MenuItem>
                  <MenuItem onClick={handlePazDetailedReportClick}>דוח פז מפורט</MenuItem>
                  <MenuItem onClick={handlePazSummaryReportClick}>דוח פז מסכם</MenuItem>
                  <MenuItem onClick={handlePazPeriodicReport}>דוח פז תקופתי</MenuItem>
                  <MenuItem onClick={handlePazAllReports}>פז כל הדוח״ות</MenuItem>
                  <MenuItem onClick={handleCarrefourExportClick}>קארפור (שורה לכל מקדמה)</MenuItem>
                  <MenuItem onClick={handleTeam3ExportClick}>צוות 3 - דו״ח ניכויים</MenuItem>
                </MenuList>
              </Menu>

              <Button
                backgroundColor="blue.300"
                onClick={handleApproveReportClick}
                isDisabled={isCreatingDocument}
              >
                אשר דו״ח
              </Button>

              <Button
                backgroundColor="green.200"
                onClick={handleAdvancePaymentRequestClick}
                isDisabled={isCreatingDocument}
              >
                דרישת תשלום מקדמות
              </Button>
              <Button
                backgroundColor="green.200"
                onClick={handleTransferFeeInvoiceClick}
                isDisabled={isCreatingDocument}
              >
                חשבונית עמלות העברה
              </Button>
              <Button
                backgroundColor="green.200"
                onClick={handleSubscriptionFeeFeeInvoiceClick}
                isDisabled={isCreatingDocument}
              >
                חשבונית דמי מנוי
              </Button>

              {/* Email Buttons */}
              <Button
                backgroundColor="blue.200"
                onClick={handleSendEmailClick}
                isDisabled={isCreatingDocument}
              >
                שלח מסמכים במייל
              </Button>

              <Button
                backgroundColor="purple.200"
                onClick={handleSendDeductionReportOnlyClick}
                isDisabled={isCreatingDocument}
              >
                שלח דו״ח ניכויים במייל
              </Button>

              {reportState === ReportState.DocumentsSent && (
                <Button
                  backgroundColor="orange.200"
                  onClick={handleSendReminderEmailClick}
                  isDisabled={isCreatingDocument}
                >
                  שלח תזכורת קבלת מסמכים
                </Button>
              )}

              <Button
                backgroundColor="purple.200"
                onClick={handleDownloadFilesClick}
                isDisabled={isCreatingDocument}
              >
                הורדת קבצים
              </Button>

              <GridItem colSpan={2}>
                <Textarea
                  value={notes || ''}
                  placeholder="הוסף הערה"
                  onChange={(event) => {
                    setNotes(event.target.value);
                  }}
                  rows={5}
                  cols={100}
                />
              </GridItem>

              <Text marginTop="15px">סה״כ העברות</Text>
              <Text marginTop="15px">₪{totalTransfers}</Text>

              <Text>סה״כ עמלות עובדים (העברות)</Text>
              <Text>₪{totalEmployeesTransferFees}</Text>

              <Text>סה״כ עמלת מעסיק (דמי שימוש)</Text>
              <Text>₪{totalCompanyServiceSubscriptionFee}</Text>

              {currentReportData?.deductTransferFeesFromSubscription &&
                totalCompanyServiceSubscriptionFee > 0 && <Text>עמלת מעסיק לאחר ניכוי</Text>}
              {currentReportData?.deductTransferFeesFromSubscription &&
                totalCompanyServiceSubscriptionFee > 0 && (
                  <Text>
                    ₪
                    {(
                      Math.max(
                        0,
                        totalCompanyServiceSubscriptionFee -
                          (totalEmployeesTransferFees || 0) / 1.18,
                      ) * 1.18
                    ).toFixed(2)}
                  </Text>
                )}

              <Select
                value={reportState}
                key={reportState}
                pr="11px"
                placeholder="בחר סטטוס"
                mt={4}
                onChange={(event) => {
                  setReportState(event.target.value);
                }}
              >
                {Object.entries(ReportState).map(([key, value]) => (
                  <option key={value} value={value}>
                    {Reports.stateText(value)}
                  </option>
                ))}
              </Select>
            </SimpleGrid>

            <SimpleGrid marginTop="30px" columns={{ sm: 2 }} gap="10px" mb="0px">
              <Text fontWeight="bold" fontSize="20px">
                סה״כ
              </Text>
              <Text fontWeight="bold" fontSize="20px">
                ₪{totalSettlementAmount}
              </Text>
            </SimpleGrid>

            <br />

            {/* Super Admin Sync Button */}
            {(() => {
              const userInfo = User.GetInfo();
              const isSuperAdmin =
                userInfo &&
                (userInfo.type === 1 ||
                  (userInfo.screens &&
                    userInfo.screens.includes('users') &&
                    userInfo.screens.includes('data-tables')));

              return (
                isSuperAdmin && (
                  <SimpleGrid marginTop="20px" columns={{ sm: 1 }} gap="10px" mb="10px">
                    <Button
                      backgroundColor="orange.200"
                      onClick={handleSyncTransfersReport}
                      isLoading={isSyncing}
                      loadingText="מסנכרן..."
                      isDisabled={isSyncing}
                    >
                      סנכרן דוח ניכויים
                    </Button>
                  </SimpleGrid>
                )
              );
            })()}

            <Table variant="simple">
              <Thead backgroundColor="green.200">
                <Tr>
                  <Th>מזהה</Th>
                  <Th>שם מסמך</Th>
                  <Th>ערך</Th>
                </Tr>
              </Thead>
              <Tbody backgroundColor="green.100">
                {documents &&
                  documents.map((doc) => (
                    <Tr key={doc.docId}>
                      <Td>{doc.docId}</Td>
                      <Td>{doc.docName}</Td>
                      <Td>{doc.docAmount != null ? `₪${doc.docAmount}` : '-'}</Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </ModalBody>
          <ModalFooter flexShrink={0}>
            <Button onClick={onClose}>סגור</Button>
            <Button onClick={handleOnUpdate}>עדכן</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Send Invoice Email Modal */}
      {currentReportData && (
        <SendInvoiceEmailModal
          isOpen={sendEmailModalOpen}
          onClose={() => setSendEmailModalOpen(false)}
          report={currentReportData}
          deductionReportOnlyMode={deductionReportOnlyMode}
        />
      )}
    </>
  );
}
